import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getHomeTokens } from '../getHomeTokens';
import { HOME_LAYOUT_SIZES } from '../homeTokens';
import { HubCardCta } from './HubCardCta';
import { HubStepBadge } from './HubStepBadge';

export interface HubActionCardWideProps {
  ctaLabel: string;
  description: string;
  onClick: () => void;
  step: string;
  title: string;
}

export function HubActionCardWide({
  ctaLabel,
  description,
  onClick,
  step,
  title,
}: HubActionCardWideProps): JSX.Element {
  const theme = useTheme();
  const homeTokens = getHomeTokens(theme);

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: { xs: 2, sm: 3 },
        minHeight: HOME_LAYOUT_SIZES.wideCardMinHeight,
        p: `${HOME_LAYOUT_SIZES.cardPadding}px`,
        borderRadius: `${HOME_LAYOUT_SIZES.cardRadius}px`,
        border: `2px solid ${homeTokens.hubCardBorder}`,
        backgroundColor: homeTokens.hubCardBackground,
        cursor: 'pointer',
        textAlign: 'left',
        width: '100%',
        transition: 'background-color 120ms ease',
        '&:hover': {
          backgroundColor: homeTokens.hubCardHoverBackground,
        },
        '&:hover [data-hub-cta]': {
          backgroundColor: homeTokens.hubCtaHoverBackground,
        },
      }}
    >
      <HubStepBadge step={step} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: `${HOME_LAYOUT_SIZES.cardContentGap}px`,
          flexGrow: 1,
          minWidth: 0,
        }}
      >
        <Typography
          component="h2"
          sx={{
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '32px',
            letterSpacing: '0.0703px',
            color: homeTokens.hubCardTitleColor,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '22.75px',
            letterSpacing: '-0.1504px',
            color: homeTokens.hubCardBodyColor,
          }}
        >
          {description}
        </Typography>
      </Box>

      <Box data-hub-cta sx={{ flexShrink: 0, alignSelf: { xs: 'flex-start', sm: 'center' } }}>
        <HubCardCta label={ctaLabel} />
      </Box>
    </Box>
  );
}
